import { useCallback, useState } from 'react'
import { useProductSegmentsSync } from './useProductSegmentsSync'

// Eigener Key: darf NIE denselben Blob wie useProductSegmentsSync's Legacy-Read (LEGACY_KEY dort)
// verwenden — sonst clobbert select() die lokalen customSegments vor der Einmal-Uebernahme (P2b Final-Review-Fix).
const SELECTED_KEY = 'goki:product-segment-selected'
const LEGACY_KEY = 'goki:product-segments'

function loadSelectedId(): string {
  try {
    const raw = localStorage.getItem(SELECTED_KEY)
    if (raw) return JSON.parse(raw) as string
    // Fallback fuer Kontinuitaet nach Deploy: einmalig aus dem (read-only) Legacy-Blob lesen.
    const legacyRaw = localStorage.getItem(LEGACY_KEY)
    if (legacyRaw) return (JSON.parse(legacyRaw) as { selectedId?: string }).selectedId ?? 'all'
  } catch {
    /* ignore (private mode / bad JSON) */
  }
  return 'all'
}

/** Segment-Auswahl (lokal je Geraet, eigener Key) + Segment-Definitionen (Server, siehe useProductSegmentsSync). */
export function useProductSegments() {
  const [selectedId, setSelectedId] = useState(loadSelectedId)
  const sync = useProductSegmentsSync()

  const select = useCallback((id: string) => {
    setSelectedId(id)
    try {
      localStorage.setItem(SELECTED_KEY, JSON.stringify(id))
    } catch {
      /* ignore (private mode / quota) */
    }
  }, [])

  return { selectedId, select, ...sync }
}
